import React, { Component } from "react";
import PromoEdit from "../../components/PromoEdit/PromoEdit";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import ImageUploader from "../ImageUploader/ImageUploader";

const style = {
	display: "grid",
	gridTemplateColumns: "repeat(1,1fr)",
	gridGap: "10px",
	gridAutoRows: "minmax(100px,auto)"
};
class Promotions extends Component {
	state = {
		createNew: false,
		title: "",
		info: "",
		descuento: 0,
		fieldValues: {
			image: ""
		},
		bgFieldValues: {
			image: ""
		}
	};
	componentDidMount() {}

	handleCreatePromotion = () => {
		this.setState({
			createNew: true
		});
	};

	handleCancel = () => {
		this.setState({
			createNew: false
		});
	};

	handleConfirm = () => {

		if(!isNaN(parseInt(this.state.descuento)))
			this.state.descuento = 0;

		if (this.state.title && this.state.info) {
			this.props.handleCreate(
				{
					titulo: this.state.title,
					descripcion: this.state.info,
					orden: 0,
					image: this.state.fieldValues.image,
					descuento: parseInt(this.state.descuento),
					backgroundImage: this.state.bgFieldValues.image
				},
				this.props.token
			);
			this.setState({
				error: false,
				createNew: false,
				titulo: "",
				descripcion: "",
				image: "",
				descuento: 0,
				backgroundImage: ""
			});
		} else {
			this.setState({ error: true });
		}
	};

	render() {
		return (
			<div>
				<Modal
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					open={this.state.createNew}
				>
					<Paper
						style={{
							display: "grid",
							width: "30%",
							padding: "50px",
							margin: "0 auto"
						}}
					>
						<div style={{ textAlign: "center" }}>
							Crear Nueva Promoción
							<br />
							<br />
							<TextField
								id="outlined-basic"
								label="Titulo"
								variant="outlined"
								value={this.state.title}
								onChange={value => this.setState({ title: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							<TextField
								id="outlined-basic"
								label="Descripción"
								variant="outlined"
								multiline
								value={this.state.info}
								onChange={value => this.setState({ info: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							<TextField
								id="outlined-basic"
								label="Descuento"
								variant="outlined"
								multiline
								value={this.state.descuento}
								onChange={value => this.setState({ descuento: value.target.value })}
								style={{ width: "90%" }}
							/>
							<br />
							Imagen
							<br />
							<br />	
							<ImageUploader fieldValues={this.state.fieldValues} />
							{this.state.error ? (
								<div>* Complete todos los campos </div>
							) : null}
							<br />	
							Imagen de fondo
							<br />
							<br />	
							<ImageUploader fieldValues={this.state.bgFieldValues} />
							{this.state.error ? (
								<div>* Complete todos los campos </div>
							) : null}
							<br />
							<Button
								onClick={this.handleConfirm}
								type="submit"
								color="primary"
								variant="contained"
								style={{ backgroundColor: "#00adee" }}
							>
								Confirmar
							</Button>
							&nbsp;&nbsp;&nbsp;
							<Button onClick={this.handleCancel} color="primary">
								Cancelar
							</Button>
						</div>
					</Paper>
				</Modal>
				<h2 style={{ width: "100%", textAlign: "left" }}>Promociones</h2>
				<div style={{ width: "100%", textAlign: "left", marginBottom: "20px" }}>
					{" "}
					<Button
						onClick={this.handleCreatePromotion}
						color="primary"
						variant="contained"
						style={{ backgroundColor: "#00adee" }}
					>
						Agregar Promoción
					</Button>
				</div>
				PROMOCIONES
				<div style={style}>
					{this.props.promotions.map(l => (
						<PromoEdit
							id={l.idPromocion}
							title={l.titulo}
							info={l.descripcion}
							descuento={l.descuento}
							imagen={l.imagen}
							imagenfondo={l.imagenfondo}
							handleSave={this.props.handleSave}
							token={this.props.token}
							handleDelete={this.props.handleDelete}
							handleSaveEdit={this.props.handleSaveEdit}
							handleSaveEditOnlyImage={this.props.handleSaveEditOnlyImage}
							handleSaveEditOnlyBackground={this.props.handleSaveEditOnlyBackground}
							handleSaveEditNoImage={this.props.handleSaveEditNoImage}
						/>
					))}
				</div>
			</div>
		);
	}
}

export default Promotions;
